import {
  ClipboardList,
  Flag,
  HeartPulse,
  Users,
  Megaphone,
  Building2,
  Wrench,
  Landmark,
  Video,
  Handshake,
} from "lucide-react";
import { Reveal, Chapter } from "./primitives";
import { useLanguage } from "../../i18n/LanguageContext";

const ICONS = [ClipboardList, Flag, HeartPulse, Users, Megaphone, Building2, Wrench, Landmark, Video, Handshake];
const SPANS = [
  "lg:col-span-2", "lg:col-span-2", "lg:col-span-2",
  "lg:col-span-3", "lg:col-span-3",
  "lg:col-span-2", "lg:col-span-2", "lg:col-span-2",
  "lg:col-span-3", "lg:col-span-3",
];

export const Universe = () => {
  const { t } = useLanguage();
  const U = t.universe;
  return (
    <section className="relative bg-kn-ice py-24 lg:py-32" data-testid="universe-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <Chapter index="" label={U.eyebrow} />
          <h2 className="mt-6 max-w-3xl text-4xl font-semibold tracking-tight text-kn-navy sm:text-5xl">
            {U.h2}
          </h2>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-kn-navy/60">{U.sub}</p>
        </Reveal>
        <div className="mt-14 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-kn-navy/10 bg-kn-navy/10 sm:grid-cols-3 lg:grid-cols-6" data-testid="universe-grid">
          {U.categories.map((c, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={c} delay={(i % 5) * 0.06} className={`h-full ${SPANS[i]}`}>
                <div className="group relative flex h-full flex-col justify-between gap-6 overflow-hidden bg-white p-6 transition-colors duration-500 hover:bg-kn-navy">
                  <div
                    className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-100"
                    style={{ background: "radial-gradient(240px 180px at 50% 120%, rgba(46,197,230,0.22), transparent 70%)" }}
                  />
                  <div className="relative flex items-center justify-between">
                    <Icon className="h-5 w-5 text-kn-blue transition-colors duration-500 group-hover:text-kn-cyan" strokeWidth={1.25} />
                    <span className="font-mono text-[10px] text-kn-navy/30 transition-colors duration-500 group-hover:text-white/40">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                  </div>
                  <p className="relative text-sm font-semibold uppercase tracking-wide text-kn-navy transition-colors duration-500 group-hover:text-white">
                    {c}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
